import styled from '@emotion/styled';

export const ExitButtonContainer = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(95% - 36px);
  transform: translate(-50%, -50%);
  padding: 18px;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
`;
